import { closestCorners, pointerWithin, type CollisionDetection } from '@dnd-kit/core';

const COLUMN = 'column:';

/**
 * What a dragged card is over, on the board. closestCorners alone compares
 * corner distances across every column, so a card in a neighbouring column
 * could win over the column under the pointer and the drop landed in the
 * wrong place. Instead the column under the pointer decides, and within it
 * the card under the pointer (or the column itself, meaning its end).
 * Keyboard drags have no pointer and keep closestCorners.
 */
export function boardCollision(cardIdsByColumn: ReadonlyMap<string, readonly string[]>): CollisionDetection {
  return (args) => {
    const under = pointerWithin(args);
    const column = under.find((c) => String(c.id).startsWith(COLUMN));
    if (!column) return under.length ? under : closestCorners(args);
    const ids = new Set(cardIdsByColumn.get(String(column.id).slice(COLUMN.length)) ?? []);
    const card = under.find((c) => ids.has(String(c.id)));
    return [card ?? column];
  };
}
